// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bRok","buttons":"styles_buttons__1npN5"};